// Copyright (c) Move Closer 2023.
import { WindowService } from '@movecloser/front-core';
function clientSideWebPiDetected() {
    const canvas = document.createElement('canvas');
    if (!(canvas.getContext && canvas.getContext('2d'))) {
        return '';
    }
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0 ? 'image/webp' : '';
}
export function detectSupportedFormats(context) {
    var _a, _b;
    const desireFormats = ['image/webp'];
    const supportedFormats = [];
    if (context.ssr || !WindowService.isDefined) {
        const acceptHeader = (_b = (_a = context.ssr) === null || _a === void 0 ? void 0 : _a.req.headers.accept) !== null && _b !== void 0 ? _b : '';
        for (const f of desireFormats) {
            if (!acceptHeader.includes(f)) {
                continue;
            }
            supportedFormats.push(f);
        }
    }
    else {
        supportedFormats.push(clientSideWebPiDetected());
    }
    return supportedFormats.filter(f => f !== null && f !== 'null').join(';');
}
